<template>
  <div>
    <!-- 生长育肥猪 -->
    <!-- <expectation-estimation v-if="fattening" :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details' /> -->
    <total-growproperties v-if="fattening" :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details' :energySystemNameA='energySystemNameA' />
    <!-- 断奶仔猪 -->
    <grow-properties-weaning v-if="weaning" :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details' :energySystemNameA='energySystemNameA'/>
    <!-- 妊娠母猪 -->
    <pregnant-total-growproperties v-if="pregnant" :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details'/>
    <!-- 哺乳母猪 -->
    <!-- <lactating-expectation-estimation v-if="sucklingow" :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details'/> -->
    <lactating-total-growproperties v-if="sucklingow" :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details'/>
    <!-- 经济效益 -->
    <template v-if="fattening && economyData==true">
      <economic-performance v-if="fattening " :isAdd="isAdd" :resId='resId' :tabKey='tabKey' :details='details' :energySystemNameA='energySystemNameA'/>
    </template>
    <template v-else-if="fattening && economyData==false">
      <div></div>
    </template>
    <template v-else>
      <div style="font-size:13px;color:#888;margin-bottom:30px">{{animalTypeName}}暂无经济效益模型</div>
    </template>
    
  </div>
</template>
<script>
import TotalGrowproperties from "./GrowProperties/TotalGrowproperties.vue";
import GrowPropertiesWeaning from './GrowProperties/GrowPropertiesWeaning.vue'
import EconomicPerformance from './GrowProperties/EconomicPerformance.vue'

//妊娠母猪
import PregnantTotalGrowproperties from "./GrowProperties/PregnantTotalGrowproperties.vue"
// 哺乳母猪
// import LactatingExpectationEstimation from './GrowProperties/LactatingExpectationEstimation.vue'
import LactatingTotalGrowproperties from './GrowProperties/LactatingTotalGrowproperties.vue'
import { getRequest } from "@/components/Common/Utils/Utils";
import { mapState } from 'vuex'
export default {
  components: {
    TotalGrowproperties,GrowPropertiesWeaning ,EconomicPerformance,PregnantTotalGrowproperties,LactatingTotalGrowproperties
     },
  props:['isAdd','resId','tabKey','details','predictionTypeCode'],
  data() {
    return {
      property: "value",
      mode: 0,
      list: [],
      estimateId: getRequest("id"),
      arrFattening: ['growingFinishing'],
      arrWeaning: ['startingPigs'],
      arrPregnant:['gestatingSows'],
    };
  },
  computed: {
    ...mapState('estimate',['dataDictionary']),
    ...mapState('economy',['predictionType','animalTypeName','economyData']),

    //生长育肥猪
    fattening(){
      return this.arrFattening.includes(this.predictionTypeCode)
    },
    //断奶仔猪
    weaning(){
      return this.arrWeaning.includes(this.predictionTypeCode)
    },
    //妊娠母猪
    pregnant(){
      return this.arrPregnant.includes(this.predictionTypeCode)
    },
    sucklingow(){
      // 哺乳母猪
      return this.predictionTypeCode === "lactatingSows";
    },
    energySystemNameA(){
      let name = ''
      let {EnergySystem} = this.dataDictionary || {}
      let {prediction} = this.details || {}
      let {energySystem} = prediction || {}
      if(EnergySystem && EnergySystem.length){
        let obj = EnergySystem.find(el => el.dictKey === energySystem) || {}
        name = obj.dictValue
      }
      return name
    },
  },
};
</script>